export default "__VITE_PUBLIC_ASSET__846bd929__"